/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 **/

import { makeAPI } from "@/frameworks/core/API";
import PartnerService from "../api";

export default function withSpaceMap(events: API.Events) {
	return {
		spaceMap: {
			search: makeAPI<WebServices.PartnerAdmin.SpaceMap.Search.Response>(
				PartnerService.partnerAdmin.spaceMap.search("partneradmin:spacemap:search", events)
			),
			save: makeAPI<WebServices.PartnerAdmin.SpaceMap.Save.Response>(
				PartnerService.partnerAdmin.spaceMap.save("partneradmin:spacemap:save", events)
			),
			detail: makeAPI<WebServices.PartnerAdmin.SpaceMap.Detail.Response>(
				PartnerService.partnerAdmin.spaceMap.detail("partneradmin:spacemap:detail", events)
			),
			update: makeAPI<WebServices.PartnerAdmin.SpaceMap.Update.Response>(
				PartnerService.partnerAdmin.spaceMap.update("partneradmin:spacemap:update", events)
			),
			delete: makeAPI<WebServices.PartnerAdmin.SpaceMap.Delete.Response>(
				PartnerService.partnerAdmin.spaceMap.remove("partneradmin:spacemap:remove", events)
			),
			label: {
				map: makeAPI<WebServices.PartnerAdmin.SpaceMap.Label.Map.Response>(
					PartnerService.partnerAdmin.spaceMap.label.map("partneradmin:spacemap:label::map", events)
				),
				scene: makeAPI<WebServices.PartnerAdmin.SpaceMap.Label.Scene.Response>(
					PartnerService.partnerAdmin.spaceMap.label.scene("partneradmin:spacemap:label::scene", events)
				),
				version: makeAPI<WebServices.PartnerAdmin.SpaceMap.Label.MapVersion.Response>(
					PartnerService.partnerAdmin.spaceMap.label.version("partneradmin:spacemap:label::version", events)
				)
			},
			scene: makeAPI<WebServices.PartnerAdmin.SpaceMap.Label.SceneDetail.Response>(
				PartnerService.partnerAdmin.spaceMap.sceneDetail("partneradmin:spacemap:label::scenedetail", events)
			)
		}
	};
}
